<hub-sub-menu></hub-sub-menu>
<div *ngIf="!!spend;">
  <div id="spend_details">
    <div class="spend_details_info">
      <span class="label">Spend Mode:</span>
      <span style="width: 11em">{{ spend.spendmode }}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Accuracy (%):</span>
      <span style="width: 7em">{{spend.accuracy}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Offset:</span>
      <span style="width: 5em">{{spend.offset}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Latest:</span>
      <span style="text-align: center">{{spend.latest | godate}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Timestamp:</span>
      <span style="text-align: center">{{spend.timestamp | godate}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Cents per Unit:</span>
      <span style="width: 6em">{{spend.centsperunit}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Units per Minute:</span>
      <span style="width: 6em">{{spend.unitsperminute}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Burntime (minutes) in {{spend.annual.year}}:</span>
      <span style="width: 3.5em">{{spend.annual.minutes}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Units Used in {{spend.annual.year}}:</span>
      <span style="width: 3.5em">{{spend.annual.units}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">{{spend.annual.year}} Spend:</span>
      <span style="width: 3.5em">{{(spend.annual.spend/100).toFixed(2)}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">{{spend.annual.year}} Savings:</span>
      <span style="width: 3.5em">{{spend.annual.saving}}</span>
    </div>
    <div class="spend_details_info">
      <span class="label">Budget:</span>
      <span style="width: 3.5em">{{spend.annual.budget}}</span>
    </div>
  </div>
  <hub-spend-chart style="height: 3em;" [dailyBurnInfo]="dailyBurns"></hub-spend-chart>
  <div class="hub_spend_time_frame">
    <div>
        <h3>Current Timeframe: {{ numberOfDays }} Days</h3>
        <h3>Burntime for this period: {{ burnTimePerPeriod.toFixed(2) }} Minutes</h3>
        <h3>Spending for this period: €{{ ((spendPerPeriod)/100).toFixed(2) }}  </h3>
        <h3 *ngIf="spend.dailyaga != 0">Burn Cost in this period: €{{ (((spendPerPeriod-(spend.dailyaga*numberOfDays))/100).toFixed(2)) }}  </h3>
        <h3 *ngIf="spend.dailyaga != 0">Aga cost in this period: €{{ ((spend.dailyaga/100)*numberOfDays).toFixed(2) }}  </h3>
        <h3>Usage for this period: {{ unitPerPeriod }} Units</h3>
    </div>
    <div>
      <button (click)="changeTimeFrame(1)">This Week </button>
      <button (click)="changeTimeFrame(2)">This Month </button>
      <button (click)="changeTimeFrame(3)">This Year </button>
      <button (click)="changeTimeFrame(4)">Last 14 Days </button>
      <button (click)="changeTimeFrame(5)">Last 90 Days </button>
      <button (click)="changeTimeFrame(6)">Last 365 Days </button>
    </div>

  </div>
  <ul class="hub_spend_daily">
    <li>
        <span class="created center" >Date</span>
        <span class="burntime center">Total Spend (€)</span>
        <span *ngIf="spend.dailyaga != 0" class="burntime center">Burn Spend (€)</span>
        <span *ngIf="spend.dailyaga != 0" class="burntime center">Aga Spend (€)</span>
        <span class="burntime center">Burntime (mins)</span>
    </li>
    <div style="display:block">
        <li *ngFor="let day of dailyBurns">
          <span class="created center" >{{day.date | godate}}</span>
          <span class="burntime center"> {{((day.spend)/100).toFixed(2)}}</span>
          <span *ngIf="spend.dailyaga != 0" class="burntime center"> {{((day.spend-spend.dailyaga)/100).toFixed(2)}}</span>
          <span *ngIf="spend.dailyaga != 0 " class="burntime center"> {{(spend.dailyaga/100).toFixed(2)}}</span>
          <span class="burntime center"> {{day.burntime}}</span>
        </li>
    </div>
  </ul>
</div>
<ng-template >No spend data yet</ng-template>
